import useImpersonationData from "./useImpersonationData";

const useActiveImpersonatedSsn = () => {
  const impersonationData = useImpersonationData();

  return impersonationData?.impersonatedSSN || null;
};

export default useActiveImpersonatedSsn;